export default "__VITE_ASSET__43GoF6D9__"